module.exports = __webpack_public_path__ + "static/media/user-3.db1268b0.png";